import { columnData, sparkLineData } from './scorecard-projects-data';
import _bundle from '../../../core/core--bundles';

// Scorecard Charts
// =============================================================================
function initChart(chart, chartData, chartColumns, chartMetrics, format) {
    let { greenLow, greenHigh, yellowLow, yellowHigh, redLow, redHigh } = chartMetrics;

    if (greenLow > greenHigh) {
        greenLow = 0;
        greenHigh = 0;
    }

    if (yellowLow > yellowHigh) {
        yellowLow = 0;
        yellowHigh = 0;
    }

    if (redLow > redHigh) {
        redLow = 0;
        redHigh = 0;
    }

    chart.kendoChart({
        title: {
            text: '',
            visible: false
        },
        legend: {
            position: 'bottom',
            visible: false
        },
        chartArea: {
            background: '',
            height: 240
        },
        seriesDefaults: {
            type: 'line',
            style: 'smooth',
            markers: {
                visible: true,
                size: 5
            }
        },
        series: [
            {
                name: '',
                data: chartData,
                color: 'rgba(89,93,110, 0.5)'
            }
        ],
        valueAxis: {
            majorGridLines: {
                color: 'rgba(89,93,110, 0.2)',
                type: 'dashDot',
                visible: true,
                step: 2
            },
            plotBands: [
                {
                    from: greenLow,
                    to: greenHigh,
                    color: 'rgba(29,201,183, 0.2)'
                },
                {
                    from: yellowLow,
                    to: yellowHigh,
                    color: 'rgba(220,156,20, 0.2)'
                },
                {
                    from: redLow,
                    to: redHigh,
                    color: 'rgba(231,96,123, 0.2)'
                }
            ],
            labels: {
                format,
                color: '#595d6e'
            },
            line: {
                visible: false
            }
        },
        categoryAxis: {
            categories: chartColumns,
            majorGridLines: {
                visible: true,
                color: 'rgba(89,93,110, 0.1)'
            },
            labels: {
                rotation: 'auto',
                color: '#595d6e',
                position: 'start'
            },
            line: {
                visible: false
            }
        },
        tooltip: {
            visible: true,
            format,
            template: '#= value #'
        }
    });
}

function createChart() {
    const $charts = $('.chart');
    const columnArray = [];
    columnData.forEach(function(item) {
        columnArray.push(item.title);
    });
    columnArray.splice(0, 1);
    for (let i = 0; i < $charts.length; i += 1) {
        const chart = $($charts[i]);
        const sparklineName = chart.attr('chart-name');
        const $sparklineElement = $(`#${sparklineName}`);
        const sparkline = $sparklineElement.data('kendoSparkline') || $sparklineElement.data('kendoDollarValue');
        const chartData = sparkline.options.data || [];
        let chartInfo = {};
        if (sparklineName === 'sparklineLaborTotalField') chartInfo = sparkLineData.totalField;
        if (sparklineName === 'sparklineLaborAverageField') chartInfo = sparkLineData.avgField;
        if (sparklineName === 'sparklineLaborProdCost') chartInfo = sparkLineData.prodCost;
        if (sparklineName === 'sparklineLaborProdHours') chartInfo = sparkLineData.prodHours;
        if (sparklineName === 'sparklineCashAvgArAge') chartInfo = sparkLineData.avgArAge;
        if (sparklineName === 'sparklineCashNetCash') chartInfo = sparkLineData.netCash;
        if (sparklineName === 'sparklineCashOverUnder') chartInfo = sparkLineData.overUnder;
        if (sparklineName === 'sparklineCashRetainage') chartInfo = sparkLineData.retainage;
        if (sparklineName === 'sparklineCompPcoAmount') chartInfo = sparkLineData.pcoAmount;
        if (sparklineName === 'sparklineCompPcoPercent') chartInfo = sparkLineData.pcoBooked;
        if (sparklineName === 'sparklineCompContigency') chartInfo = sparkLineData.potentialUpside;
        initChart(chart, chartData, columnArray, chartInfo.metrics, chartInfo.format);
    }
}

function sparklinesFadeIn(e) {
    // Render fired when the chart is ready to render on screen.
    // Render fires twice before and after dataBound
    const { sender } = e;
    const { element } = sender;
    const $el = element.closest('.collapsible--sparkline.--fade-in');
    if ($el.hasClass('--js-data-bound')) {
        $el.addClass('--show');
    }
}
function sparklinesDataBound(e) {
    const { sender } = e;
    const { element } = sender;
    const $el = element.closest('.collapsible--sparkline.--fade-in');
    $el.addClass('--js-data-bound');
}

let laborCreated = false;
let cashCreated = false;
let projectionCreated = false;

function createLaborSparklines() {
    $('#sparklineLaborTotalField').kendoSparkline({
        data: sparkLineData.totalField.data,
        chartArea: {
            background: 'transparent'
        },
        type: 'area',
        tooltip: {
            visible: true,
            format: '{0:n}'
        },
        dataBound: sparklinesDataBound,
        render: sparklinesFadeIn
    });

    $('#sparklineLaborAverageField').kendoSparkline({
        data: sparkLineData.avgField.data,
        chartArea: {
            background: 'transparent'
        },
        type: 'area',
        tooltip: {
            visible: true,
            format: '{0:c2}'
        },
        dataBound: sparklinesDataBound,
        render: sparklinesFadeIn
    });

    $('#sparklineLaborProdCost').kendoSparkline({
        data: sparkLineData.prodCost.data,
        chartArea: {
            background: 'transparent'
        },
        type: 'area',
        tooltip: {
            visible: true,
            format: '{0:n4}'
        },
        dataBound: sparklinesDataBound,
        render: sparklinesFadeIn
    });

    $('#sparklineLaborProdHours').kendoSparkline({
        data: sparkLineData.prodHours.data,
        chartArea: {
            background: 'transparent'
        },
        type: 'area',
        tooltip: {
            visible: true,
            format: '{0:n4}'
        },
        dataBound: sparklinesDataBound,
        render: sparklinesFadeIn
    });

    laborCreated = true;
}

function createCashSparklines() {
    $('#sparklineCashAvgArAge').kendoSparkline({
        type: 'area',
        chartArea: {
            background: 'transparent'
        },
        data: sparkLineData.avgArAge.data,
        seriesColors: ['#6698DF'],
        tooltip: {
            visible: true,
            format: '{0:n2}'
        },
        dataBound: sparklinesDataBound,
        render: sparklinesFadeIn
    });

    $('#sparklineCashNetCash').kendoSparkline({
        data: sparkLineData.netCash.data,
        chartArea: {
            background: 'transparent'
        },
        type: 'line',
        tooltip: {
            visible: true,
            format: '{0:c2}'
        },
        dataBound: sparklinesDataBound,
        render: sparklinesFadeIn
    });

    $('#sparklineCashRetainage').kendoSparkline({
        chartArea: {
            background: 'transparent'
        },
        type: 'line',
        data: sparkLineData.retainage.data,
        tooltip: {
            visible: true,
            format: '{0:c2}'
        },
        dataBound: sparklinesDataBound,
        render: sparklinesFadeIn
    });

    $('#sparklineCashOverUnder').kendoSparkline({
        data: sparkLineData.overUnder.data,
        chartArea: {
            background: 'transparent'
        },
        type: 'area',
        tooltip: {
            visible: true,
            format: '{0:c2}'
        },
        dataBound: sparklinesDataBound,
        render: sparklinesFadeIn
    });
    cashCreated = true;
}

function createProjectionSparklines() {
    $('#sparklineCompPcoAmount').kendoSparkline({
        data: sparkLineData.pcoAmount.data,
        chartArea: {
            background: 'transparent'
        },
        type: 'area',
        tooltip: {
            visible: true,
            format: '{0:c0}'
        },
        dataBound: sparklinesDataBound,
        render: sparklinesFadeIn
    });

    $('#sparklineCompPcoPercent').kendoSparkline({
        data: sparkLineData.pcoBooked.data,
        chartArea: {
            background: 'transparent'
        },
        type: 'area',
        tooltip: {
            visible: true,
            format: '{0:n2} %'
        },
        dataBound: sparklinesDataBound,
        render: sparklinesFadeIn
    });

    $('#sparklineCompContigency').kendoSparkline({
        data: sparkLineData.potentialUpside.data,
        chartArea: {
            background: 'transparent'
        },
        type: 'area',
        tooltip: {
            visible: true,
            format: '{0:c0}'
        },
        dataBound: sparklinesDataBound,
        render: sparklinesFadeIn
    });

    projectionCreated = true;
}

function updateTags(that) {
    const parent = $(that.element).parents('.card');
    const thatTag = parent.find('.tag');
    thatTag.removeClass('tag--red tag--yellow tag--green');
    const sparklineName = that.element[0].id;
    const chartData = that.options.data || [];
    let chart = {};
    if (sparklineName === 'sparklineLaborTotalField') chart = sparkLineData.totalField;
    if (sparklineName === 'sparklineLaborAverageField') chart = sparkLineData.avgField;
    if (sparklineName === 'sparklineLaborProdCost') chart = sparkLineData.prodCost;
    if (sparklineName === 'sparklineLaborProdHours') chart = sparkLineData.prodHours;
    if (sparklineName === 'sparklineCashAvgArAge') chart = sparkLineData.avgArAge;
    if (sparklineName === 'sparklineCashNetCash') chart = sparkLineData.netCash;
    if (sparklineName === 'sparklineCashOverUnder') chart = sparkLineData.overUnder;
    if (sparklineName === 'sparklineCashRetainage') chart = sparkLineData.retainage;
    if (sparklineName === 'sparklineCompPcoAmount') chart = sparkLineData.pcoAmount;
    if (sparklineName === 'sparklineCompPcoPercent') chart = sparkLineData.pcoBooked;
    if (sparklineName === 'sparklineCompContigency') chart = sparkLineData.potentialUpside;

    const lastVal = chartData[chartData.length - 1] || String.fromCharCode(160);
    thatTag.text(kendo.toString(lastVal, chart.format));
    if (chart.metrics === undefined) return;
    const { redHigh, redLow, yellowHigh, yellowLow, greenHigh, greenLow } = chart.metrics;
    if (lastVal <= redHigh && lastVal >= redLow) thatTag.addClass('tag--red');
    if (lastVal <= yellowHigh && lastVal >= yellowLow) thatTag.addClass('tag--yellow');
    if (lastVal <= greenHigh && lastVal >= greenLow) thatTag.addClass('tag--green');
}

function refreshSparklines(tabName) {
    let sparklines;
    if (tabName === 'Labor')
        sparklines = $('#sparklineLaborTotalField,#sparklineLaborAverageField,#sparklineLaborProdCost,#sparklineLaborProdHours');
    if (tabName === 'Cash') sparklines = $('#sparklineCashAvgArAge,#sparklineCashNetCash,#sparklineCashRetainage,#sparklineCashOverUnder');
    if (tabName === 'PCO & Contingency') sparklines = $('#sparklineCompPcoAmount,#sparklineCompPcoPercent,#sparklineCompContigency');

    sparklines.each(function() {
        const that = $(this).data('kendoSparkline');
        that.refresh();
        updateTags(that);
    });
}

function setLoading(tabName) {
    let sparklines;
    if (tabName === 'Labor')
        sparklines = $('#sparklineLaborTotalField,#sparklineLaborAverageField,#sparklineLaborProdCost,#sparklineLaborProdHours');
    if (tabName === 'Cash') sparklines = $('#sparklineCashAvgArAge,#sparklineCashNetCash,#sparklineCashRetainage,#sparklineCashOverUnder');
    if (tabName === 'PCO & Contingency') sparklines = $('#sparklineCompPcoAmount,#sparklineCompPcoPercent,#sparklineCompContigency');
    sparklines.each(function() {
        const that = $(this);
        const $el = that.closest('.collapsible--sparkline.--fade-in');
        $el.removeClass('--js-data-bound');
        $el.removeClass('--show');
    });
}

// =============================================================================
// Scorecard Sparklines
// =============================================================================
function renderSparklines(tab) {
    if (tab === 'Labor') {
        if (!laborCreated) createLaborSparklines();
        else refreshSparklines(tab);
    }
    if (tab === 'Cash') {
        if (!cashCreated) createCashSparklines();
        else refreshSparklines(tab);
    }
    if (tab === 'PCO & Contingency') {
        if (!projectionCreated) createProjectionSparklines();
        else refreshSparklines(tab);
    }
}

export default function() {
    _bundle.add({
        name: 'Project Scorecard: Run Sparklines',
        event: ['on:BundleReady'],
        fn() {
            renderSparklines('Labor');
            $(document).on('on:RenderSparklines', function(e, { tabName }) {
                renderSparklines(tabName);
            });
            $(document).on('on:ScorecardDataStart', function(e, { tabName }) {
                setLoading(tabName);
            });
        }
    });
    _bundle.add({
        name: 'Finance Scorecard: Run Charts on Scorecard Click',
        event: ['on:PageUpdate'],
        fn() {
            createChart();
        }
    });
    _bundle.add({
        name: 'Finance Scorecard: Charts Resizing',
        event: ['on:Resize'],
        fn() {
            kendo.resize($('.chart__wrap'));
            kendo.resize($('.sparkline__wrap'));
        }
    });
}
